import jsonp from 'jsonp';
import axios from 'axios';
import globalConfig from '../utiles/globalConfig';
import languages from './languages';
import { convertParamToString } from '../utiles';
import { clearDisable } from '../plugins/clickThrottling';
import qs from 'qs';

export const MAIN_HOST = globalConfig.getMainHost();

export const PLATFORM_HOST = '';
export const ACHIEVEMENT_ID = 9999;
export const APP_ID = 182267189223689;
export const HOST = `//geventsapi.${MAIN_HOST}/`;
export const ACTIVITY_HOST = `//gactivityapi.${MAIN_HOST}/`;
export const PASSPORT_HOST = `//gpassport.${MAIN_HOST}/`;
export const STORE_HOST = `//gstore.${MAIN_HOST}/`;
export const SUPPORT_REQ_URL = `//gsupport.${MAIN_HOST}/index`;
const vgmHost = ['gnjoy.hk', 'gamemart.vn', 'vgm.vn','gnjoy.game'];
export const HOME_HOST = vgmHost.includes(MAIN_HOST)
  ? `//gwww.${MAIN_HOST}/`
  : `//www.${MAIN_HOST}/`;
export const H5_HOST = `//h5.${MAIN_HOST}/`;
export const FUNCTION_LIST_STORE = 'functionList';
export let ERR_CODE = '0';
export const DEFAULT_LANGUAGE = 'en-US';
const SUCCESS_RESULT_CODE = 1;

export let appendEntryPageParams = function (params) {
  if (params.needntEntryParam) {
    return params;
  }
  let entryPageParam = globalConfig.getAllWebviewEntryParams();
  return Object.assign(entryPageParam || {}, params);
};

export const getBroswerLanguage = function () {
  return navigator.language || navigator.userLanguage;
};

export let post = function (action, params, config = {}) {
  languages.init();
  if (!params['language']) {
    params['language'] =
      getHrefParam('language') || getBroswerLanguage() || DEFAULT_LANGUAGE;
    params['appLanguage'] =
      getHrefParam('appLanguage') || getBroswerLanguage() || DEFAULT_LANGUAGE;
  }
  if (globalConfig.isTiktokMiniProgram()) {
    params['passportToken'] = getHrefParam('passportToken');
  }
  return new Promise((resolve, reject) => {
    axios
      .post(action, qs.stringify(params), config)
      .then(function (response) {
        clearDisable();
        var res = response.data;
        if (SUCCESS_RESULT_CODE != res.result) {
          var errmsg =
            (res && res.msg && res.msg.replace(/\[\-\d*\]/, '')) || '';
          errmsg = languages.get(res.code) || errmsg;
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          });
        } else {
          resolve({
            errmsg: '',
            data: res.data,
            res: res
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  });
};

export let getJSON = function (action, params) {
  if (!params.notNeedInitLanguage) {
    languages.init();
  }
  if (!params['language']) {
    params['language'] =
      getHrefParam('language') || getBroswerLanguage() || DEFAULT_LANGUAGE;
    params['appLanguage'] =
      getHrefParam('appLanguage') || getBroswerLanguage() || DEFAULT_LANGUAGE;
  }
  if (globalConfig.isTiktokMiniProgram()) {
    params['passportToken'] = getHrefParam('passportToken');
  }
  if (params.notNeedInitLanguage) {
    delete params.notNeedInitLanguage;
  }
  try {
    let roleName = params['roleName'];
    if (roleName && /[\#\&\?]/.test(roleName)) {
      params['roleName'] = encodeURIComponent(roleName);
    }
  } catch (e) {}
  params = appendEntryPageParams(params);
  if (typeof window != 'undefined') {
    return getJSONP(action, params);
  } else {
    return get(action, params);
  }
};

export let getJSONWithoutEntryParam = function (action, params) {
  languages.init();
  if (!params['language']) {
    params['language'] =
      getHrefParam('language') || getBroswerLanguage() || DEFAULT_LANGUAGE;
    params['appLanguage'] =
      getHrefParam('appLanguage') || getBroswerLanguage() || DEFAULT_LANGUAGE;
  }
  if (typeof window != 'undefined') {
    return getJSONP(action, params);
  } else {
    return get(action, params);
  }
};

export let get = function (action, params) {
  return new Promise((resolve, reject) => {
    if (params && !params['language']) {
      params['language'] =
        getHrefParam('language') || getBroswerLanguage() || DEFAULT_LANGUAGE;
      params['appLanguage'] =
        getHrefParam('appLanguage') || getBroswerLanguage() || DEFAULT_LANGUAGE;
    }
    if (globalConfig.isTiktokMiniProgram()) {
      params['passportToken'] = getHrefParam('passportToken');
    }
    axios
      .get(action, {
        params
      })
      .then(function (response) {
        clearDisable();
        var res = response.data;
        if (SUCCESS_RESULT_CODE != res.result) {
          var errmsg =
            (res && res.msg && res.msg.replace(/\[\-\d*\]/, '')) || '';
          errmsg = languages.get(res.code) || errmsg;
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          });
        } else {
          resolve({
            errmsg: '',
            data: res.data,
            res: res
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  });
};

let getJSONP = function (action, params) {
  return new Promise((resolve, reject) => {
    var paramStr = convertParamToString(params || {});
    jsonp(
      action,
      {
        prefix: 'jsonpCallback',
        param: paramStr
      },
      (err, response) => {
        clearDisable();
        if (err || SUCCESS_RESULT_CODE != response.result) {
          var errmsg =
            response && response.msg && response.msg.replace(/\[\-\d*\]/, '');
          errmsg = response ? languages.get(response.code) || errmsg : errmsg;
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          });
        } else {
          resolve({
            errmsg: '',
            data: response.data,
            res: response
          });
        }
      }
    );
  });
};

export let getHrefParam = function (paramName) {
  return globalConfig.getHrefParam(paramName);
};

/*
         去除字符串前后的空格
 */
export let trim = function (str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
};

export const loadConverstData = function (loadData, map) {
  var result = {};
  /* eslint-disable no-unused-vars */
  for (let key in map) {
    let mapKey = map[key];
    let val = loadData[mapKey] || '';
    result[key] = val;
  }
  return result;
};

export let getGameId = function () {
  return getHrefParam('game_id') || getHrefParam('gameid');
};

export const formatTextAreaVal = function (inputVal) {
  // 匹配换行符==> <br/>，空白字符==>&nbsp;
  return inputVal.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
};

export let getShareContent = function (config, action) {
  return new Promise((resolve, reject) => {
    post(action, {
      achievementId: config.achievementId,
      appId: APP_ID,
      gameId: getGameId(),
      serverId: config.serverId,
      fbid: config.fbid || '',
      loginAccount: config.name,
      timestamp: new Date().getTime(),
      roleId: config.roleId,
      roleName: config.roleName,
      devicePlate: 'pc',
      pic: ''
    }).then(({ errmsg, data }) => {
      if (errmsg) {
        resolve({
          link: '',
          token: '',
          errmsg: errmsg
        });
      } else {
        resolve({
          link: data.LINK,
          token: data.TOKEN,
          errmsg: ''
        });
      }
    });
  });
};

var formatTimeBit = function (time) {
  if (time < 10) {
    time = '0' + time;
  }
  return time;
};

// 得到标准时区的时间的函数
export let getLocalTime = function (i, timestamp) {
  // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
  if (typeof i !== 'number') return;
  var d = new Date();
  // 得到1970年一月一日到现在的秒数
  var len = d.getTime(timestamp);
  // 本地时间与GMT时间的时间偏移差
  var offset = d.getTimezoneOffset() * 60000;
  // 得到现在的格林尼治时间
  var utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
};
export let mapDateTime = function (time) {
  var date = getLocalTime(9, time);
  return (
    date.getFullYear() +
    '-' +
    formatTimeBit(date.getMonth() + 1) +
    '-' +
    formatTimeBit(date.getDate())
  );
};
// 倒计时
export let countDown = function (seconds) {
  let allSeconds = seconds;
  let remainSecond = allSeconds % 60; // 取餘，剩下的秒數
  let allMinute = parseInt(allSeconds / 60); // 總共有多少分鐘
  let allHour = parseInt(allMinute / 60); // 總共有多少個小時
  let remainMinute = allMinute - allHour * 60;
  let remainHour = allHour;

  remainSecond = remainSecond < 10 ? '0' + remainSecond : remainSecond;
  remainMinute = remainMinute < 10 ? '0' + remainMinute : remainMinute;
  remainHour = remainHour < 10 ? '0' + remainHour : remainHour;

  let remainTime = remainHour + ':' + remainMinute + ':' + remainSecond;
  return remainTime;
};

/**
 * 文件切片
 * @param {*} file 文件
 * @param {*} piece 切片大小，单位字节
 * @returns
 */
export const sliceFile = (file, piece = 1024 * 1024 * 5) => {
  console.log('slice', file);
  let totalSize = file.size; // 文件总大小
  let start = 0; // 每次上传的开始字节
  let end = start + piece; // 每次上传的结尾字节
  let chunks = [];
  while (start < totalSize) {
    // 根据长度截取每次需要上传的数据
    // File对象继承自Blob对象，因此包含slice方法
    let blob = file.slice(start, end);
    chunks.push(blob);
    start = end;
    end = start + piece;
  }
  return chunks;
};

/**
 * xhr的post请求
 * @param {*} url 请求链接
 * @param {*} formData 表单数据
 * @returns
 */
export const xhtPost = (url, formData) => {
  // 打印时间戳
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          res.result === 1 ? resolve(res) : reject(res);
        } else {
          reject(xhr.responseText);
        }
      }
    };
    xhr.send(formData);
  });
};

/**
 * xhr的put请求
 * @param {*} url 请求的链接
 * @param {*} file 请求的文件
 * @returns
 */
export const xhrPut = (url, file) => {
  // 打印时间戳
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.responseText);
        } else {
          reject(xhr.responseText);
        }
      }
    };
    xhr.send(file);
  });
};
